import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { admin, user } from "./auth/role";
import { ac } from "./auth/ac";

// Node.js 25+ ships localStorage as a global but without a backing file the
// getItem/setItem methods are undefined. better-auth detects localStorage and
// tries to use it — patch the missing methods so SSR doesn't crash.
if (
  typeof window === "undefined" &&
  typeof localStorage !== "undefined" &&
  typeof (localStorage as Storage).getItem !== "function"
) {
  const noop = () => null;
  Object.defineProperties(localStorage, {
    getItem:    { value: noop, writable: true, configurable: true },
    setItem:    { value: () => {}, writable: true, configurable: true },
    removeItem: { value: () => {}, writable: true, configurable: true },
    clear:      { value: () => {}, writable: true, configurable: true },
    key:        { value: noop, writable: true, configurable: true },
  });
}

export const authClient = createAuthClient({
  baseURL: process.env.BETTER_AUTH_URL,
  plugins: [
    adminClient({
      ac,
      roles: {
        admin,
        user,
      },
    }),
  ],
});

export const { signIn, signUp, useSession } = authClient;
